import { render, staticRenderFns } from "./ErrorModalComponent.vue?vue&type=template&id=ae09152a&"
import script from "./ErrorModalComponent.vue?vue&type=script&lang=ts&"
export * from "./ErrorModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports